<section *ngIf="tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'alreadylogedIn' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-md btn-gradient hover-transform-none"
                                routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section *ngIf="!tokenValid">
    <div class="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-inner text-center">
                        <h2 class="title">{{'login' | translate}}</h2>
                        <ul class="page-list">
                            <li class="rbt-breadcrumb-item"><a routerLink="/home">{{'home' | translate}}</a></li>
                            <li>
                                <div class="icon-right"><i class="feather-chevron-right"></i></div>
                            </li>
                            <li class="rbt-breadcrumb-item active">{{'login' | translate}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="rbt-become-area bg-color-white rbt-section-gap">
        <div class="container">
            <div class="row pt--60 g-5" style="justify-content: center;">
                <div class="col-lg-8">
                    <div class="rbt-contact-form contact-form-style-1 max-width-auto">
                        <div class="section-title text-center">
                            <span class="subtitle bg-primary-opacity">{{'login' | translate}}</span>
                        </div>
                        <hr class="mb--30">

                        <form #loginForm="ngForm" id="loginForm" novalidate>
                            <div class="row row-15">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <input name="User_name" id="User_name" type="text"
                                            [(ngModel)]="userLogin.userNameOrEmailAddress" ngModel required
                                            #User_name="ngModel" placeholder="{{'userNameorEmail' | translate}}"
                                            [maxlength]="100">
                                        <span class="focus-border"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <input name="Password" #input id="Password" type="password"
                                            [(ngModel)]="userLogin.password" ngModel required #Password="ngModel"
                                            placeholder="{{'Password' | translate}}" [minlength]="8">
                                        <span class="focus-border"></span>
                                        <i class="feather-eye pass-eye"
                                            (click)="changeInput(input)"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12" style="margin-bottom: 20px;">
                                    <span class="forgetpasswordspan" data-bs-toggle="modal"
                                        data-bs-target="#exampleModal">{{'forgetPass' | translate}}</span>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-submit-group">
                                    <button type="submit" class="rbt-btn btn-md btn-gradient hover-transform-none w-100"
                                        [class.spinner]="loading" (click)="login()"
                                        [disabled]="!(loginForm.valid && loginForm.dirty) || loading">
                                        <span class="icon-reverse-wrapper">
                                            <span class="btn-text">{{'login' | translate}}</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>

            <div class="rbt-team-modal modal fade rbt-modal-default" id="exampleModal" tabindex="-1"
                aria-labelledby="exampleModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button #closeModal type="button" class="rbt-round-btn" data-bs-dismiss="modal" aria-label="Close">
                                <i class="feather-x"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="inner">
                                <div class="rbt-team-details">
                                    <div class="author-info" style="text-align: center;">
                                        <h4 class="title">{{'recoverPass' | translate}}</h4>
                                        <span class="designation theme-gradient">{{'enterEmailRecover' | translate}}</span>
                                    </div>
                                </div>
                                <div style="text-align: center;">
                                    <form class="form rbt-search-style-1" #resetForm="ngForm">
                                        <div class="row">
                                            <input name="resetEmail" id="resetEmail" type="email" [email]="true" style="padding-right: 15px;"
                                                [(ngModel)]="resetEmailValue" ngModel required #resetEmail="ngModel"
                                                placeholder="{{'Email' | translate}}">
                                            <span class="focus-border"></span>
                                        </div>

                                        <div class="row">
                                            <div class="col-lg-12" style="margin-top: 20px;">
                                                <button class="rbt-btn btn-coral" [class.spinner]="loading" [disabled]="!(resetForm.valid && resetForm.dirty) || loading" (click)="sendResetPass()">{{'send' | translate}}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="top-circle-shape"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>